export const CRPSteps = {
	alarmSignals: { number: 4, complete: false },
};
